import { React } from "react";
import { useState } from "react";
import {
  Text,
  Flex,
  Button,
  IconButton,
  Grid,
  GridItem,
  Box,
  Image,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { HashLink } from "react-router-hash-link";

const NavBar = () => {
  const [display, changeDisplay] = useState("none");
  const [mobileDisplay, setMobileDisplay] = useState("none");
  const openMobileMenu = () => setMobileDisplay("flex");
  const closeMobileMenu = () => setMobileDisplay("none");

  // Nav Text Style
  const textStyle = {
    color: "white",
    lineHeight: "24px",
    letterSpacing: "-0.022em",
    textAlign: "center",
    fontWeight: "500",
  };

  return (
    <Flex
      backgroundColor="#242424"
      px={{ base: 6, lg: 8, xl: 12 }}
      py={2}
      maxWidth="100vw"
      height="12vh"
    >
      <Grid
        templateColumns={{
          base: "repeat(2, 1fr)",
          lg: "repeat(5, 1fr)",
          xl: "repeat(4, 1fr)",
        }}
        width="100%"
        height="100%"
        alignItems="center"
      >
        <GridItem height="100%" display="flex" alignItems="center" colSpan={1}>
          <Box
            height="100%"
            display="flex"
            alignItems="center"
            cursor="pointer"
            onClick={() => {
              window.location.href = `/`;
            }}
          >
            <Image
              src="/LOGO_KURIA_NEW_2.png"
              alt="Logo"
              height="4vh"
              width="auto"
            />
          </Box>
        </GridItem>
        <GridItem
          display={{ base: "none", lg: "flex" }}
          justifyContent="space-between"
          alignItems="center"
          colSpan={{ base: 1, lg: 3, xl: 2 }}
        >
          <a href="/">
            <Text {...textStyle} fontSize={{ base: "16px", "2xl": "1.5rem" }}>
              BERANDA
            </Text>
          </a>
          <HashLink to="/tentangkami">
            <Text {...textStyle} fontSize={{ base: "16px", "2xl": "1.5rem" }}>
              TENTANG KAMI
            </Text>
          </HashLink>

          <a href="/kuriabar">
            <Text {...textStyle} fontSize={{ base: "16px", "2xl": "1.5rem" }}>
              KURIA BAR
            </Text>
          </a>
          <a href="/kuriamesh">
            <Text {...textStyle} fontSize={{ base: "16px", "2xl": "1.5rem" }}>
              KURIA MESH
            </Text>
          </a>
          <a href="/proyek">
            <Text {...textStyle} fontSize={{ base: "16px", "2xl": "1.5rem" }}>
              PROYEK
            </Text>
          </a>
          <a href="/faq">
            <Text {...textStyle} fontSize={{ base: "16px", "2xl": "1.5rem" }}>
              FAQ
            </Text>
          </a>
          <a href="/news">
            <Text {...textStyle} fontSize={{ base: "16px", "2xl": "1.5rem" }}>
              NEWS
            </Text>
          </a>
        </GridItem>

        <GridItem
          display={{ base: "none", lg: "flex" }}
          justifyContent="flex-end"
          alignItems="center"
          colSpan={{ base: 1, lg: 1 }}
        >
          <Button
            borderRadius="base"
            fontWeight="700"
            onClick={() => {
              window.location.href = "/contact";
            }}
            color="#392f2e"
            fontSize={{ base: "16px", "2xl": "1.5rem" }}
            padding={{ base: "12px", "2xl": "2rem 2rem" }}
          >
            KONTAK KURIA
          </Button>
        </GridItem>
        <GridItem
          display={{ base: "flex", lg: "none" }}
          alignItems="center"
          justifyContent="flex-end"
        >
          <IconButton
            aria-label="Open Menu"
            variant="ghost"
            colorScheme="#e93d27"
            size="lg"
            icon={<HamburgerIcon color="white" />}
            onClick={openMobileMenu}
            _hover={{
              backgroundColor: "gray.700",
              color: "white",
            }}
            display={{ base: "flex", lg: "none" }}
          />
        </GridItem>
      </Grid>
      <NavBarMobile display={mobileDisplay} changeDisplay={closeMobileMenu} />
    </Flex>
  );
};

export default NavBar;

const NavBarMobile = ({ display, changeDisplay }) => {
  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      backgroundColor="#242424"
      zIndex={200}
      flexDirection="column"
      display={display}
    >
      {/* Close Button */}
      <Flex justify="flex-end">
        <IconButton
          aria-label="Close Menu"
          mt={4}
          mr={6}
          size="lg"
          icon={<CloseIcon color="white" />}
          variant="ghost"
          colorScheme="whiteAlpha"
          onClick={() => changeDisplay("none")}
          _hover={{ bg: "rgba(255,255,255,0.1)" }}
        />
      </Flex>

      {/* Mobile Menu Links */}
      <Flex
        flexDir="column"
        alignItems="center"
        gap={8}
        justifyContent="center"
        flex={1}
      >
        <a href="/" onClick={() => changeDisplay("none")}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            BERANDA
          </Text>
        </a>
        <HashLink to="/tentangkami" onClick={() => changeDisplay("none")}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            TENTANG KAMI
          </Text>
        </HashLink>
        <a href="/kuriabar" onClick={() => changeDisplay("none")}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            KURIA BAR
          </Text>
        </a>
        <a href="/kuriamesh" onClick={() => changeDisplay("none")}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            KURIA MESH
          </Text>
        </a>
        <a href="/proyek" onClick={() => changeDisplay("none")}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            PROYEK
          </Text>
        </a>
        <a href="/faq" onClick={() => changeDisplay("none")}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            FAQ
          </Text>
        </a>
        <a href="/news" onClick={() => changeDisplay("none")}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            NEWS
          </Text>
        </a>
        <a
          href="https://wa.me/6285117255773"
          target="_blank"
          rel="noreferrer"
          onClick={() => changeDisplay("none")}
        >
          <Text
            color="white"
            fontWeight="bold"
            fontSize="xl"
            _hover={{ color: "#e93d27" }}
            transition="color 0.3s"
          >
            KONTAK KURIA
          </Text>
        </a>
      </Flex>
    </Flex>
  );
};
